import { cn } from "../lib/cn";

/**
 * Atrium mark: an arch within an arch — rooms opening onto a shared hall.
 * The inner arch carries the accent, so the mark follows the chosen accent.
 */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={cn("size-7", className)} aria-hidden>
      <path d="M8 24V14.5a8 8 0 0 1 16 0V24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
      <path d="M13 24v-6.5a3 3 0 0 1 6 0V24" fill="none" stroke="var(--accent)" strokeWidth="2.6" strokeLinecap="round" />
    </svg>
  );
}

export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-2 text-fg", className)}>
      <LogoMark />
      <span className="text-lg font-semibold tracking-tight">Atrium</span>
    </span>
  );
}
